document.addEventListener("DOMContentLoaded", function () {
    const observer = new MutationObserver(() => {
        const isCartOpen = document.querySelector(".show-mini-cart");
        document.body.style.overflowY = isCartOpen ? "hidden" : "";
        document.documentElement.style.overflowY = isCartOpen ? "hidden": "";
        console.log(
            "MutationObserver: Cart state changed, overflow set to",
            isCartOpen ? "hidden" : "visible",
        );
    });

    // Start observing DOM changes
    observer.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ["class"],
    });
});
